const siteId = import.meta.env.VITE_CUSTOMERIO_CIO_ID;

function getCio() {
  if (!(window as any)._cio) {
    (window as any)._cio = [];
    const cio = (window as any)._cio;

    for (const eventName of [
      'load',
      'identify',
      'sidentify',
      'track',
      'page',
      'on',
      'off',
    ]) {
      cio[eventName] = (...rest: any[]) => cio.push([eventName, ...rest]);
    }
  }
  return (window as any)._cio;
}

let added = false;
function loadScript() {
  if (added || !siteId) return;
  added = true;

  getCio();
  const t = document.createElement('script');
  t.async = true;
  t.id = 'cio-tracker';
  t.dataset.siteId = siteId;
  t.dataset.useArrayParams = 'true';
  t.dataset.useInApp = 'true';
  t.dataset.autoShow = 'true';
  t.src = 'https://assets.customer.io/assets/track.js';
  document.head.append(t);
}

export const inAppMessage = {
  loadScript,
  identify(data: { id: string; email?: string; phone?: string }) {
    getCio().identify(data);
  },
};
